module.exports = __webpack_public_path__ + "static/media/user-checklist-background-top.56070b6e.png";